import { WsSalutation } from './WsSalutation';
import { Type } from '@hugendubel/ws_client';

export class WsBonusShopCustomerData {
    salutation: WsSalutation;
    firstName?: string;
    lastName: string;
    loyaltyCardNumbers: Array<string>;
    pseudoCustomer: boolean;

    constructor(
        salutation: WsSalutation,
        firstName: string | undefined,
        lastName: string,
        loyaltyCardNumbers: Array<string>,
        pseudoCustomer: boolean
    ) {
        this.salutation = salutation;
        this.firstName = firstName;
        this.lastName = lastName;
        this.loyaltyCardNumbers = loyaltyCardNumbers;
        this.pseudoCustomer = pseudoCustomer;
    }

    static fromApi(json: any): WsBonusShopCustomerData {
        return new WsBonusShopCustomerData(
            WsSalutation.fromCode(Type.notEmptyString(json.salutationCode, 'BonusShopCustomerData.salutationCode')),
            Type.optional.string(json.firstName, 'BonusShopCustomerData.firstName'),
            Type.notEmptyString(json.lastName, 'BonusShopCustomerData.lastName'),
            Type.array(json.loyaltyCardNumbers, 'BonusShopCustomerData.loyaltyCardNumbers').map(card =>
                Type.string(card, 'BonusShopCustomerData.loyaltyCardNumber')
            ),
            Type.boolean(json.pseudoCustomer, 'BonusShopCustomerData.pseudoCustomer')
        );
    }
}
